
import { Switch } from 'antd'
import React from 'react'

export default function SwitchCustom({
    defaultChecked,
    checked = false,
    disabled = false,
    onChange = () => { },
    textOn = "Yes",
    textOff = "No"
}) {
    return (
        <div className='wrapper-switch-custom'>
            <Switch
                defaultChecked={defaultChecked}
                className='switch-custom'
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                checkedChildren={textOn}
                unCheckedChildren={textOff}
            />
        </div>
    )
}
